import React, { useState, useEffect } from 'react';
import './Reviews.css';

function Reviews({ API_URL, userId, userLikes }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    show_id: '',
    artist_id: '',
    artist_performance: 5,
    sound_quality: 5,
    crowd_vibe: 5,
    venue_logistics: 5,
    price_to_value: 5,
    notes: ''
  });

  useEffect(() => {
    if (userId) {
      loadReviews();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const loadReviews = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/reviews/user/${userId}`);
      if (response.ok) {
        const data = await response.json();
        setReviews(data.reviews || []);
      }
    } catch (err) {
      console.error('Error loading reviews:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/api/reviews`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userId,
          ...formData
        })
      });
      
      if (response.ok) {
        setShowForm(false);
        loadReviews();
        setFormData({
          show_id: '',
          artist_id: '',
          artist_performance: 5,
          sound_quality: 5,
          crowd_vibe: 5,
          venue_logistics: 5,
          price_to_value: 5,
          notes: ''
        });
      }
    } catch (err) {
      console.error('Error creating review:', err);
    }
  };

  const StarRating = ({ value, onChange, label }) => (
    <div className="rating-field">
      <label>{label}</label>
      <div className="stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            className={`star ${star <= value ? 'filled' : ''}`}
            onClick={() => onChange(star)}
          >
            ★
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="reviews">
      <div className="reviews-header">
        <h2>My Reviews</h2>
        <button className="btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : 'Write Review'}
        </button>
      </div>

      {showForm && (
        <form className="review-form" onSubmit={handleSubmit}>
          <h3>Write a Review</h3>
          <input
            type="text"
            placeholder="Show ID"
            value={formData.show_id}
            onChange={(e) => setFormData({ ...formData, show_id: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Artist ID"
            value={formData.artist_id}
            onChange={(e) => setFormData({ ...formData, artist_id: e.target.value })}
            required
          />
          
          <StarRating
            label="Artist Performance"
            value={formData.artist_performance}
            onChange={(val) => setFormData({ ...formData, artist_performance: val })}
          />
          <StarRating
            label="Sound Quality"
            value={formData.sound_quality}
            onChange={(val) => setFormData({ ...formData, sound_quality: val })}
          />
          <StarRating
            label="Crowd Vibe"
            value={formData.crowd_vibe}
            onChange={(val) => setFormData({ ...formData, crowd_vibe: val })}
          />
          <StarRating
            label="Venue Logistics"
            value={formData.venue_logistics}
            onChange={(val) => setFormData({ ...formData, venue_logistics: val })}
          />
          <StarRating
            label="Price to Value"
            value={formData.price_to_value}
            onChange={(val) => setFormData({ ...formData, price_to_value: val })}
          />
          
          <textarea
            placeholder="Optional notes..."
            value={formData.notes}
            onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
            rows={4}
          />
          
          <button type="submit" className="btn-primary">Submit Review</button>
        </form>
      )}

      {loading ? (
        <div className="loading">Loading reviews...</div>
      ) : reviews.length === 0 ? (
        <div className="empty-state">
          <p>No reviews yet. Write your first review!</p>
        </div>
      ) : (
        <div className="reviews-list">
          {reviews.map((review) => (
            <div key={review.id} className="review-card">
              <div className="review-header">
                <h3>{review.shows?.name || 'Show'}</h3>
                <div className="overall-rating">
                  {review.overall_rating?.toFixed(1)} ⭐
                </div>
              </div>
              <p className="review-meta">
                {review.shows?.venue_name} • {review.shows?.event_date && 
                  new Date(review.shows.event_date).toLocaleDateString()}
              </p>
              <div className="rating-breakdown">
                <div className="rating-item">
                  <span>Performance:</span>
                  <span>{'★'.repeat(review.artist_performance)}</span>
                </div>
                <div className="rating-item">
                  <span>Sound:</span>
                  <span>{'★'.repeat(review.sound_quality)}</span>
                </div>
                <div className="rating-item">
                  <span>Crowd:</span>
                  <span>{'★'.repeat(review.crowd_vibe)}</span>
                </div>
                <div className="rating-item">
                  <span>Venue:</span>
                  <span>{'★'.repeat(review.venue_logistics)}</span>
                </div>
                <div className="rating-item">
                  <span>Value:</span>
                  <span>{'★'.repeat(review.price_to_value)}</span>
                </div>
              </div>
              {review.notes && (
                <p className="review-notes">{review.notes}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Reviews;
